import script from "./BookCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookCard.vue?vue&type=script&setup=true&lang=ts"

import "./BookCard.vue?vue&type=style&index=0&id=92a1b206&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92a1b206"]])

export default __exports__